import Auth from '../../../../../auth';

export default function EquipmentDetailsImageUploadController(
  $scope,
  $uibModalInstance,
  fileUploaderService,
  equipmentId
) {
  'ngInject';

  $scope.isProfileImage = false;
  $scope.fileTypeValidation = true;
  $scope.errorFlagMaxImgs = false;
  $scope.errorFlagMaxImgSize = false;
  $scope.errorText = '';

  $scope.uploader = fileUploaderService;

  $scope.uploader.url = '/api/media/images';

  $scope.uploader.headers = {
    Authorization: Auth.getAuthorizationHeader()
  };

  $scope.uploader.removeAfterUpload = true;

  $scope.uploader.filters.push({
    name: 'fileTypeFilter',
    fn: function(item) {
      $scope.errorFlagMaxImgs = false;
      $scope.errorFlagMaxImgSize = false;

      if (/\/(png|jpeg|jpg)$/.test(item.type)) {
        $scope.fileTypeValidation = true;
        return true;
      } else {
        $scope.fileTypeValidation = false;
        $scope.uploading = false;
        $scope.uploader.clearQueue();
        return false;
      }
    }
  });

  $scope.uploader.onSuccessItem = function(data, response) {
    if ($scope.isProfileImage) {
      response.data.isNewProfilePicture = true;
    }

    $uibModalInstance.close(response);
  };

  $scope.uploader.onErrorItem = function(item, response) {
    //unfortunately there is no way to stop the error from getting thrown in the console with this library
    $scope.uploading = false;

    if (_.includes(response.message, 'Maximum number')) {
      $scope.errorFlagMaxImgs = true;
    } else {
      $scope.errorFlagMaxImgSize = true;
    }
    $scope.fileTypeValidation = true;
  };

  $scope.uploader.onBeforeUploadItem = function(item) {
    if (equipmentId) {
      item.formData.push({
        equipmentId: equipmentId
      });
    }

    if ($scope.description) {
      item.formData.push({
        description: $scope.description
      });
    }

    if ($scope.isProfileImage) {
      item.formData.push({
        isProfileImage: true
      });
    }
  };

  $scope.uploadImage = function() {
    $scope.uploading = true;
    $scope.uploader.uploadAll();
  };

  $scope.cancel = function() {
    $scope.uploader.clearQueue();
    $uibModalInstance.close();
  };
}
